<template>
  <div class="job-detailing" style="margin-top: -1rem">
    <div class="d-flex flex-wrap">
      <job-list class="job-list_header" :data="[job]">
        <template slot="joblink" slot-scope="{ job, insidejob }">
          <span v-if="insidejob">
            {{ job.id_extern }}
          </span>
          <a
            v-else
            class="text-decoration-underline dd"
            @click="
              $router.push({
                name: 'JobAssemblingDetail',
                params: { jobId: job.id, jobData: job },
              })
            "
          >
            {{ job.id_extern }}
          </a>
        </template>
        <template slot="date-item" slot-scope="{ date }">
          <job-list-date-item
            :date="date"
            :class="{
              obscure:
                !currentWorkableDate || date.id != currentWorkableDate.id,
            }"
          >
          </job-list-date-item>
        </template>

        <template slot="button" slot-scope="{ job }">
          <button
            v-if="
              job.status == app.options.Job.STATUS.planned ||
              job.status == app.options.Job.STATUS.inprocess
            "
            type="button"
            :class="{
              btn: true,
              'btn-secondary default-hover': !jobWorkable,
              'btn-next default-hover  float-right': jobWorkable,
            }"
            :disabled="!jobWorkable"
            @click="doJob"
          >
            {{
              job.status == app.options.Job.STATUS.inprocess
                ? (job.type == app.options.Job.TYPE.servicing
                    ? "Serviceauftrag"
                    : "Montage") + " fortsetzen"
                : (job.type == app.options.Job.TYPE.servicing
                    ? "Serviceauftrag"
                    : "Montage") + " beginnen"
            }}
          </button>
          <button
            v-else-if="job.status == app.options.Job.STATUS.cancelled"
            class="btn btn-relevant"
            @click="doJob"
          >
            Abgebrochen
          </button>
          <button
            v-else-if="job.status == app.options.Job.STATUS.unfinished"
            class="btn btn-highlighted"
            @click="doJob"
          >
            Unvollständig abgeschlossen
          </button>
          <button
            v-else-if="job.status == app.options.Job.STATUS.finished"
            class="btn btn-primary"
            @click="doJob"
          >
            Abgeschlossen
          </button>
        </template>
      </job-list>
    </div>
    <tab-container
      v-if="job"
      :tabs="{
        ubersicht: 'Übersicht',
        meldungen: 'Meldungen',
      }"
      :initial-tab="this.meldungenSelected ? 'meldungen' : 'ubersicht'"
      class="
        col
        tab-container--vertical tab-container--navigation
        job-tabs-header
      "
      nav-class="job-report__steps__nav"
    >
      <template slot="ubersicht" slot-scope="tabContainer">
        <div>
          <spinner v-if="!job" class="ml-auto mr-auto mt-xxl"></spinner>

          <template v-else>
            <div class="job-detail container-fluid">
              <div class="row">
                <div class="col col-4">
                  <div class="row">
                    <div class="col col-12">
                      <div class="card job-detail__contacts">
                        <div class="card__header">
                          <h2>Kontakte</h2>
                        </div>

                        <ul
                          v-if="job.contacts.length"
                          class="job-detail__contacts__list list-reset"
                        >
                          <li
                            v-for="contact in job.contacts"
                            :key="contact.id"
                            class="job-detail__contacts__list-item"
                          >
                            {{
                              `${app.options.Contact.TYPES[contact.type]}: ${
                                contact.name
                              }`
                            }}
                            <br />

                            <a
                              v-if="contact.tel.main"
                              :href="`tel:${contact.tel.main}`"
                            >
                              {{ contact.tel.main }}
                            </a>

                            <template
                              v-if="contact.tel.main && contact.email.main"
                              >,
                            </template>

                            <a
                              v-if="contact.email.main"
                              :href="`mailto:${contact.email.main}`"
                            >
                              {{ contact.email.main }}
                            </a>
                          </li>
                        </ul>

                        <i v-else>Keine Kontake angegeben.</i>
                      </div>
                    </div>
                    <div class="col col-12">
                      <div class="card job-detail__location">
                        <div class="card__header">
                          <h2>
                            {{
                              "Adresse " +
                              (job.type == app.options.Job.TYPE.servicing
                                ? "Serviceauftrag"
                                : "Montage")
                            }}
                          </h2>
                        </div>

                        {{
                          `${job.locations[0].street} ${job.locations[0].street_number}`
                        }}<br />
                        {{
                          `${job.locations[0].postal_code} ${job.locations[0].city}`
                        }}

                        <div class="job-detail__location__map-container">
                          <google-map
                            v-if="job.locations.length"
                            :api-key="env.GOOGLE_MAPS_API_KEY"
                            :address="`${job.locations[0].street} ${job.locations[0].street_number}, ${job.locations[0].postal_code} ${job.locations[0].city}`"
                            class="job-detail__location__map"
                          >
                          </google-map>
                          <a
                            class="btn btn-primary"
                            :href="`https://www.google.com/maps/dir/?api=1&destination=${job.locations[0].street}, ${job.locations[0].postal_code} ${job.locations[0].city}`"
                            target="_blank"
                            >Navigieren</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-4">
                  <div class="row">
                    <!-- Notes -->
                    <div class="col col-12 job-detail__infos">
                      <div class="card job-detail__instruction">
                        <div class="card__header">
                          <h2>
                            {{
                              __(
                                `jobs.views.detail.${job.typeName}.labels.instruction`
                              )
                            }}
                          </h2>
                        </div>

                        <div
                          v-if="instruction.length"
                          v-html="instruction"
                          class="job-detail__instruction__content"
                        ></div>
                        <i v-else>Keine Anleitung angegeben.</i>

                        <button
                          v-if="instruction.length > 300"
                          class="
                            btn btn-plain btn-text
                            d-block
                            ml-auto
                            text-right
                          "
                          @click="
                            $windows.showTextWindow(
                              job.instruction,
                              __(
                                `jobs.views.detail.${job.typeName}.labels.instruction`
                              ),
                              $event
                            )
                          "
                        >
                          mehr...
                        </button>
                      </div>
                    </div>
                    <div class="col col-12 job-detail__infos">
                      <div class="card job-detail__notes">
                        <div class="card__header">
                          <h2>Notiz vom Projektleiter</h2>
                        </div>

                        <div
                          v-if="managerNote.length"
                          v-html="managerNote"
                          class="job-detail__notes__content"
                        ></div>
                        <i v-else>Keine Notizen angegeben.</i>

                        <button
                          v-if="managerNote.length > 300"
                          class="
                            btn btn-plain btn-text
                            d-block
                            ml-auto
                            text-right
                          "
                          @click="
                            $windows.showTextWindow(
                              job.infos.common,
                              'Notiz vom Projektleiter',
                              $event
                            )
                          "
                        >
                          mehr...
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="row">
                    <!-- Fittings -->
                    <div class="col col-12">
                      <div class="card job-detail__fittings">
                        <div class="card__header">
                          <h2>Beschlägefächer</h2>
                        </div>

                        <ul class="job-detail__fittings__locations list-reset">
                          <li
                            v-for="fittingLocation in job.fittings_locations"
                            :key="fittingLocation"
                          >
                            #{{ fittingLocation }}
                          </li>
                        </ul>

                        <div class="job-detail__buttons">
                          <button
                            class="btn btn-auto-width btn-primary"
                            :disabled="!job.tools.length"
                            @click="showTools"
                          >
                            Spezialwerkzeuge
                          </button>

                          <button
                            :class="{
                              'btn btn-auto-width': true,
                              'btn-next': fittingsCheckable && !fittingsChecked,
                              'btn-primary':
                                !fittingsCheckable || fittingsChecked,
                            }"
                            @click="showFittingsWindow"
                            :disabled="checkableFittings == 0"
                          >
                            Kontrolle Beschlägeliste
                          </button>
                        </div>
                      </div>

                      <div class="card job-detail__files mt-mdsm">
                        <div class="job-detail__buttons">
                          <button
                            class="btn btn-primary btn-full-width"
                            @click="
                              $windows.showFilesWindow(
                                'Allgemeine Dokumente',
                                job.files,
                                null,
                                null,
                                'full'
                              )
                            "
                            :disabled="!job.files.length"
                          >
                            Allgemeine Dokumente
                          </button>
                          <button
                            class="btn btn-primary btn-full-width"
                            @click="
                              $windows.showFilesWindow(
                                'Dokumente',
                                partsLocationFiles,
                                null,
                                null,
                                'full'
                              )
                            "
                            :disabled="!partsLocationFiles.length"
                          >
                            Alle Dokumente
                          </button>
                        </div>
                        <div class="job-detail__buttons mt-mdsm">
                          <button
                            class="btn btn-primary btn-full-width"
                            disabled
                          >
                            Skizzen
                          </button>
                          <button
                            class="btn btn-primary btn-full-width"
                            disabled
                          >
                            Bilder
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="col col-12 mt-mdsm">
                      <div class="card job-detail__status">
                        <div class="card__header">
                          <h2>
                            Status der
                            {{
                              job.type == app.options.Job.TYPE.servicing
                                ? "Serviceauftrag"
                                : "Montage"
                            }}
                          </h2>
                        </div>

                        <div class="row pt-mdsm">
                          <div class="col-6 job-detail__status__done">
                            <span class="job-detail__status__amount">{{
                              job.parts.filter(
                                (p) => p.report && p.report.status == 1
                              ).length
                            }}</span>
                            Abgeschlossen
                          </div>
                          <div class="col-6 job-detail__status__open">
                            <span class="job-detail__status__amount">{{
                              job.parts.filter(
                                (p) => !p.report || p.report.status == 0
                              ).length
                            }}</span>
                            Offen
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template slot="meldungen" slot-scope="tabContainer">
        <div class="job-detail container-fluid">
          <div class="row">
            <div class="col-12">
              <button
                class="btn btn-primary float-right mb-2"
                @click="showJobTechnicianMessagesWindow()"
              >
                Neue Meldung erstellen
              </button>
            </div>
          </div>
          <messages :data-src="allMessages" :showFilter="false" base-class="job-messages">
            <template slot="message" slot-scope="{ message }">
              <job-message-tab
                class="job-messages-tab"
                :messages="message"
                base-class="job-messages__message"
              ></job-message-tab>
            </template>
          </messages>
        </div>
      </template>
    </tab-container>
    <button
      :class="{
        'btn mt-mdsm rounded-circle btn-qr-icon': true,
        'btn-next': !code.code,
        'btn-secondary': code.code ? true : false,
      }"
      @click="scanCode"
    >
      <img :src="icon('qr-icon.svg')" />
    </button>
    <div v-if="scanedCode" class="qr-alerts">
      <span class="warning-arrow"></span>
      <div class="d-flex flex-column align-items-end">
        <div
          :class="{
            alert: true,
            'alert-warning': scanedCode,
            'alert-success': !scanedCode,
          }"
        >
          <span v-html="scanedCodeMessage"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JobViewBase from "./Job/ViewBase";
import JobToolsWindow from "../windows/JobTools";
import JobFittingsWindow from "smartdoors-shared/js/components/Jobs/JobFittingsList";
import JobSuvaWindow from "../windows/JobSuva";
import JobMessagesWindow from "../windows/JobMessages";
import JobTechnicianMessageWindow from "../windows/JobTechnicianMessage";

import JobMessageTab from "./Job/JobMessageTab";
import JobMessagePreview from "./Job/JobMessagePreview";
import { mapState } from "vuex";
import { cloneObject } from "smartdoors-shared/js/helpers/common";
import QrScannerWindow from "../windows/QrScanner";

export default {
  extends: JobViewBase,
  components: {
    "job-message-tab": JobMessageTab,
    "job-message-preview": JobMessagePreview,
  },
  props: {
    loadJobFromApi: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loadPart: false,
      scanedCode: false,
      scanedCodeMessage: "QR Code nicht vorhanden",
      fittingKeys: [],
      meldungenSelected: false,
      codeData: {
        code: null,
        image: null,
      },
    };
  },
  computed: {
    ...mapState({
      job: function (state) {
        return state.jobs.stacks.current.length
          ? state.jobs.stacks.current[0]
          : this.jobData;
      },
    }),
    managerNote() {
      if (
        !this.job.infos ||
        !("common" in this.job.infos) ||
        !this.job.infos.common
      ) {
        return "";
      }

      return this.job.infos.common.length > 300
        ? this.job.infos.common.substr(0, 300) + "..."
        : this.job.infos.common;
    },
    instruction() {
      return this.job && this.job.instruction
        ? this.job.instruction.length > 300
          ? this.job.instruction.substr(0, 300) + "..."
          : this.job.instruction
        : "";
    },
    partsLocationFiles() {
      let allfiles = [];
      if (this.job && this.job.parts) {
        this.job.files.forEach((element) => {
          allfiles.push(element);
        });

        this.job.parts.forEach((element) => {
          element.location_files.forEach((location) => {
            allfiles.push(location);
          });
          element.fittings.forEach((fittings) => {
            fittings.files.forEach((fittings_file) => {
              allfiles.push(fittings_file);
            });
          });
        });
        return allfiles;
      }
      return [];
    },
    jobFittings() {
      const fittings = {};

      for (const part of this.job.parts) {
        for (const fitting of part.fittings) {
          if (fitting.category == 2) {
            if (!(fitting.type in fittings)) {
              fittings[fitting.type] = cloneObject(fitting);
            } else {
              fittings[fitting.type]["amount"] += fitting["amount"];
            }
          }
        }
      }

      return Object.values(fittings);
    },
    previewMessages() {
      return "messages_technician" in this.job && this.job.messages_technician
        ? this.job.messages_technician.slice(0, 2)
        : [];
    },
    allMessages() {
      let messages = [];
      messages.push(this.job.messages_technician);
      return messages;
    },

    code() {
      const code =
        this.part && this.part.codes.length
          ? this.part.codes[this.part.codes.length - 1]
          : this.codeData;

      if (code && code.image && (!("src" in code.image) || !code.image.src)) {
        code.image = this.loadImage(code.image);
      }

      return code;
    },
  },
  beforeCreate() {
    this.$store.state.jobs.stacks.current = [];
  },
  created() {
    this.meldungenSelected =
      this.$route.query.meldungen == "true" ? true : false;
  },
  methods: {
    showTools($triggerEvent = null) {
      this.$windows.showWindow(
        JobToolsWindow,
        {},
        this.job.tools,
        $triggerEvent ? $triggerEvent.target : null
      );
    },
    async showJobTechnicianMessagesWindow($triggerEvent = null) {
      const message = await this.$windows.showWindow(
        JobTechnicianMessageWindow,
        {
          title:
            this.__(`jobs.common.types.${this.job.typeName}`) +
            ` ${this.job.id_extern}`,
        },
        $triggerEvent ? $triggerEvent.target : null
      );
      if (message) {
        if (navigator.onLine) {
          this.app.isLoading = true;
        }
        await this.$store.dispatch("jobs/sendCommonTechnicianMessage", {
          id: this.job.id,
          message,
        });
        location.search = "?meldungen=true";
        this.app.isLoading = false;
      }
    },
    showJobMessagesWindow($triggerEvent = null) {
      this.$windows.showWindow(
        JobMessagesWindow,
        { messages: this.job.messages_technician },
        $triggerEvent ? $triggerEvent.target : null
      );
    },
    async showFittingsWindow($triggerEvent = null) {
      const messages = {};

      for (const message of this.job.messages_technician) {
        if (
          message.source_type ==
          this.app.options.Actions.jobs.TECHNICIAN_MESSAGE_FITTINGS
        ) {
          messages[message.context_info.fitting.type] = message.data.text;
        }
      }

      const result = await this.$windows.showWindow(
        JobFittingsWindow,
        {
          windowSize: "full",
          btnMargin: "0.9375rem",
          windowTitle: "Kontrolle Beschläge",
          fittings: this.jobFittings,
          messages,
          iconSrc: this.icon,
          allowEdit: this.fittingsCheckable,
        },
        $triggerEvent ? $triggerEvent.target : null
      );

      if (result) {
        if (navigator.onLine) {
          this.app.isLoading = true;

          await this.$store.dispatch("jobs/updateFittings", {
            id: this.job.id,
            data: result,
          });

          this.app.isLoading = false;

          for (fittingKey in this.fittingKeys) {
            updateRemoteTask.thenAlways([
              "store",
              "dispatch:jobs/deleteOverride",
              { id: this.job.id, key: fittingKey },
            ]);
          }
        } else {
          this.updatJobLocal(result);
        }
      }
    },

    updatJobLocal(results) {
      let fittings = results.fittings;
      let parts = [];
      let overrideKey = "fittings_" + this.job.id + "_";
      let pindex = 0;
      for (const part of this.job.parts) {
        parts.push({ id: part.id, fittings: [] });
        for (const fitting of part.fittings) {
          for (const editedFiting of fittings) {
            if (editedFiting.type == fitting.type) {
              overrideKey = overrideKey + fitting.id;
              fitting["status"] = editedFiting.status;
              parts[pindex].fittings.push({ ...fitting });
            }
          }
        }
        pindex++;
      }

      setTimeout(() => {
        this.fittingKeys.push(overrideKey);

        let updateData = {
          id: this.job.id,
          parts: [...parts],
          fittings: [...fittings],
          message_fittings: [...results.messages],
        };
        this.$store.dispatch("jobs/addOverride", {
          data: updateData,
          key: overrideKey,
        });

        this.$store.dispatch("jobs/commit");
        this.$store.dispatch("jobs/updateRemote", updateData);
      }, 300);
    },

    async doJobScan(job_id, id = null) {
      let paramId = {};
      if (id) {
        paramId = { partID: id };
      }
      const reportRoute = {
        name: "JobParts",
        params: { jobId: job_id, loadJobFromApi: true },
        query: paramId,
      };

      this.app.isLoading = true;
      await this.jobDataLoading;
      this.app.isLoading = false;

      this.$router.push(reportRoute);
    },
    async doJob($triggerEvent = null, id = null) {
      let paramId = {};
      if (id) {
        paramId = { partID: id };
      }
      const reportRoute = {
        name: "JobParts",
        params: { jobId: this.job.id },
        query: paramId,
      };

      if (this.job.status == this.app.options.Job.STATUS.planned) {
        // show suva window if job status is 'planned' (not 'inprocess' yet)
        const result = await this.$windows.showWindow(
          JobSuvaWindow,
          {},
          this.app.options.Suva,
          $triggerEvent ? $triggerEvent.target : null
        );

        if (result === true) {
          if (!navigator.onLine) {
            this.job.status = this.app.options.Job.STATUS.inprocess;

            setTimeout(() => {
              this.app.isLoading = false;
              this.$router.push(reportRoute);
            }, 1200);

            for (const dates of this.job.dates) {
              if (dates.id === this.currentWorkableDate.id) {
                dates.status = this.app.options.JobDate.STATUS.inprocess;
              }
            }
          }

          this.app.isLoading = true;

          // after the user accepted the suva, we'll update the stauts of the current job date to 'inpcrocess'
          // this should automatically set the status of the job also to 'inprocess' and so the suva won't show up again
          await this.$store.dispatch("jobs/updateRemote", {
            id: this.job.id,
            dates: [
              {
                id: this.currentWorkableDate.id,
                status: this.app.options.JobDate.STATUS.inprocess,
              },
            ],
          });

          this.app.isLoading = false;
          this.$router.push(reportRoute);
        }
      } else {
        this.app.isLoading = true;
        await this.jobDataLoading;
        this.app.isLoading = false;

        this.$router.push(reportRoute);
      }
    },
    async doJobPart(id = null, partId = null) {
      const partRoute = {
        name: "JobPart",
        params: { jobId: id, partId: partId, loadJobFromApi: true },
      };
      this.$router.push(partRoute);
    },

    async scanCode($triggerEvent = null) {
      this.loadPart = true;
      this.scanedCode = false;
      this.scanedCodeMessage = "QR Code nicht vorhanden";
      const result = await this.$windows.showWindow(
        QrScannerWindow,
        $triggerEvent ? $triggerEvent.target : null
      );
      if (result) {
        const code = await this.$store.dispatch("jobs/respondQrCodeRequests", {
          code: result.code,
        });
        if (code.data) {
          this.loadPart = false;
          this.scanedCode = true;
          if (code.data.status && code.data.status == 1) {
            if (code.data.myJob) {
              this.doJobPart(code.data.job_id, code.data.part_id);
            } else {
              this.scanedCode = true;
              const manager = code.data.jobs.manager.name;

              this.scanedCodeMessage =
                "Sie besitzen keine Zugriffsrechte auf dieses laufendes Projekt. Projekt <b>" +
                code.data.jobs.id_extern +
                "</b> wird durch <b>" +
                manager +
                "</b> verwaltet.";
            }
          } else {
            this.doJobScan(code.data.job_id, code.data.part_id);
          }
        } else {
          // location.reload();
          this.scanedCode = true;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.job-detail {
  $cardsGridSpacing: map-get($spacers, mdsm) / 2;

  .cards,
  .cards .col {
    padding-left: $cardsGridSpacing;
    padding-right: $cardsGridSpacing;

    .card {
      height: 100%;
    }
  }

  .card {
    padding-left: map-get($spacers, mdsm);
    padding-right: map-get($spacers, mdsm);
  }

  &__buttons {
    display: flex;
    justify-content: space-between;

    button {
      padding-top: map-get($spacers, mdsm);
      padding-bottom: map-get($spacers, mdsm);
      width: calc(50% - #{map-get($spacers, mdsm) / 2});
      line-height: 1.2;
      min-width: 0;
    }
  }

  &__infos {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > .card {
      height: auto !important;
    }
  }

  &__fittings {
    &__locations {
      padding-top: map-get($spacers, lg);
      padding-bottom: map-get($spacers, xl);
      display: flex;
      justify-content: space-around;
      font-weight: map-get($font-weights, bold);
      font-size: map-get($font-sizes, xl);
    }
  }

  &__location {
    &__map-container {
      position: relative;

      > a {
        position: absolute;
        bottom: 23px;
        right: 20%;
      }
    }

    &__map {
      display: block;
      width: 100%;
      height: 250px;
      margin-top: map-get($spacers, md);
    }
  }

  &__status {
    &__amount {
      display: block;
      font-weight: map-get($font-weights, medium);
      font-size: map-get($font-sizes, xl);
      margin-bottom: map-get($spacers, mdlg);
    }

    &__done,
    &__open {
      text-align: center;
    }

    &__open {
      color: $state-highlighted;
      font-weight: map-get($font-weights, medium);
    }
  }

  &__messages {
    flex: 1 0 auto;

    &-container {
      display: flex;
      flex-direction: column;
    }

    &__list-item {
      flex: 1 1 auto;

      &:not(:last-child) {
        padding-bottom: map-get($spacers, xl);
        margin-bottom: map-get($spacers, xs);
        border-bottom: 1px solid $border-dark;
      }
    }
  }

  &__message {
    &__date {
      text-align: right;
    }

    &__body {
      display: flex;
      margin-top: map-get($spacers, xs);
    }

    &__info {
      flex: 0 1 auto;
      padding-right: map-get($spacers, md);
      text-align: center;
      font-weight: map-get($font-weights, medium);
      line-height: 1.2;
      min-width: 65px;

      > img:not(:first-child) {
        margin-top: map-get($spacers, sm);
      }
    }

    &__text {
      flex: 1 1 auto;
    }
  }
}
.btn-qr-icon {
  width: 64px;
  height: 64px;
  display: block;
  padding: 12px;
  min-width: auto;
  position: fixed;
  right: 20px;
  bottom: 20px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.qr-alerts {
  position: fixed;
  bottom: 30px;
  right: 90px;
  .warning-arrow {
    width: 10px;
    height: 10px;
    background: #ff9956;
    position: absolute;
    top: 50%;
    right: -4px;
    z-index: -1;
    transform: translate(00%, -50%);
    clip-path: polygon(50% 0%, 100% 50%, 50% 100%);
  }
}
</style>